var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_958_85267)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_958_85267",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_958_85267)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_958_85267",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_958_85267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0067 19.1666C8.99154 19.1647 7.98364 18.9958 7.02334 18.6666C5.70588 18.2111 4.50911 17.4623 3.52334 16.4766C3.22819 16.1845 2.95574 15.8702 2.70834 15.5366C2.1029 14.7468 1.63211 13.8624 1.315 12.9191C0.998095 11.9778 0.838183 10.9907 0.84167 9.99748V9.78748C0.877126 7.97054 1.45587 6.20585 2.50334 4.72081H2.51C2.8122 4.29149 3.15036 3.88865 3.52084 3.51665C4.58561 2.45015 5.89719 1.66298 7.33917 1.22498C8.2015 0.962937 9.0979 0.830106 9.99917 0.830813C10.9026 0.830829 11.8012 0.963924 12.6658 1.22581C14.1052 1.66425 15.4142 2.45112 16.4767 3.51665C16.8553 3.89317 17.2005 4.30194 17.5083 4.73831C18.5543 6.22428 19.1308 7.98973 19.1633 9.80665V10.0325C19.1632 11.0184 19.0019 11.9977 18.6858 12.9316C18.3698 13.8666 17.9028 14.7435 17.3033 15.5275C16.2093 16.98 14.7065 18.0728 12.9875 18.6658C12.0267 18.9952 11.0182 19.1642 10.0025 19.1658L10.0067 19.1666ZM7.57167 11.3991L4.09917 12.5166L3.62334 14.5508L3.54 14.9025C3.76374 15.1956 4.00619 15.474 4.26584 15.7358C5.13629 16.6087 6.19416 17.2719 7.35917 17.675L9.405 16.4091V12.8333H9.53667L7.56667 11.4L7.57167 11.3991ZM12.4883 11.3658L11.515 12.0733L10.47 12.8308H10.5458V16.3708L12.6533 17.6716C14.1726 17.1447 15.5018 16.1797 16.4733 14.8983L15.9225 12.58L12.4808 11.3875L12.4875 11.3666L12.4883 11.3658ZM12.8508 10.3175L16.22 11.4841L18.1142 9.83498C18.088 8.2259 17.5774 6.66207 16.6492 5.34748L14.2483 5.16581L12.0958 8.13665L12.825 10.3866L12.8475 10.3191L12.8508 10.3175ZM5.8725 5.14415L3.3725 5.33248C2.4422 6.64464 1.92905 8.20676 1.9 9.81498L3.76584 11.4375L7.20334 10.3308L7.91334 8.14998L5.87084 5.14415H5.8725ZM6.77167 4.45415L8.8 7.43665H11.2067L13.3183 4.51998L12.365 2.23415C11.6003 2.00405 10.8061 1.88725 10.0075 1.88748C9.20869 1.88656 8.41408 2.00308 7.64917 2.23331L6.7225 4.48331L6.76917 4.45165L6.77167 4.45415Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_958_85267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSport);
export default __webpack_public_path__ + "static/media/icon-sport.1fa703d97b910fd9a2eeeba51048525d.svg";
export { ForwardRef as ReactComponent };